
<p-breadcrumb
  id="common-breadcrumbs"
  *ngIf="showBreadcrumb"
  [model]="menuItems"
  styleClass="lms-breadcrumb"
></p-breadcrumb>
<div *ngIf="showBack" class="flex back-btn-container">
  <div class="back-btn" (click)="backClicked()">
    <em class="pi pi-chevron-left back-icon"></em>
  </div>
  <span class="current-route-lbl">{{ currentRouteLabel }}</span>
</div>
